import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import {
  Hero,
  About,
  Programs,
  Gallery,
  Stories,
  Donate,
  Footer,
} from "./containers";
import { Navbar } from "./components";
import {
  initMarkers,
  scrollToSection,
  startSmoothScroll,
  stopSmoothScroll,
} from "./lib/motion";
import "./App.css";

const SITE_URL = "https://sales-gray-theta.vercel.app/";

const App = () => {
  const { hash } = useLocation();

  /* Arriving at /#possibility from another route should land on the section
     rather than the top of the page. */
  useEffect(() => {
    startSmoothScroll();
    const stopMarkers = initMarkers();
    return () => {
      stopMarkers();
      stopSmoothScroll();
    };
  }, []);

  useEffect(() => {
    if (!hash) return undefined;
    const id = hash.slice(1);
    const timer = window.setTimeout(() => scrollToSection(id), 220);
    return () => window.clearTimeout(timer);
  }, [hash]);

  return (
    <div className="App">
      <Helmet>
        <title>
          SALES – Social Advancement for Livelihood and Educational Support
        </title>
        <meta
          name="description"
          content="SALES supports people living with stroke, paralysis and disability in Barishal, Bangladesh — through physiotherapy, help with treatment costs, inclusive schooling and livelihood training."
        />
        <link rel="canonical" href={SITE_URL} />
        <meta property="og:url" content={SITE_URL} />
      </Helmet>

      <Navbar />

      <main id="main">
        <Hero />
        <About />
        <Programs />
        <Gallery />
        <Stories />
        <Donate />
      </main>

      <Footer />
    </div>
  );
};

export default App;
